/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ConfigurationDto } from '../models/configuration-dto';
import { findAll } from '../fn/configuration-controller/find-all';
import { FindAll$Params } from '../fn/configuration-controller/find-all';

@Injectable({ providedIn: 'root' })
export class ConfigurationControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll()` */
  static readonly FindAllPath = '/v1/configuration/{idUser}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll$Response(
    params: FindAll$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<ConfigurationDto>>> {
    return findAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll(params: FindAll$Params, context?: HttpContext): Observable<Array<ConfigurationDto>> {
    return this.findAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ConfigurationDto>>): Array<ConfigurationDto> => r.body)
    );
  }
}
